import DailyReward from "@/components/DailyReward";
import IncomingMessage from "@/components/IncomingMessage";
import InstallAppDrawer from "@/components/InstallAppDrawer";
import MobileNavigation from "@/components/MobileNavigation";
import RequestNotificationPermission from "@/components/RequestNotificationPermission";
import Sidebar from "@/components/Sidebar";
import { DEFAULT_USER_NAME } from "@/constants";
import SubscriptionModalContext from "@/context/modal";
import withAuthGuard from "@/libs/hoc/auth-guard";
import withPullToRefresh from "@/libs/hoc/pull-to-refresh";
import usePolyfills from "@/libs/hooks/polyfills";
import { fullscreenStore } from "@/libs/stores/fullscreen.store";
import { Box, Flex } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedLayout = observer(({ user }) => {
  // const { isMobile } = useDeviceInfo();
  const { getMaxHeightRepresentation } = usePolyfills();
  const maxH = getMaxHeightRepresentation();
  const { pathname } = useLocation();
  const { isSubscriptionModalOpen } = useContext(SubscriptionModalContext);
  const isChat = pathname.startsWith("/chat/");
  const hideNavigation = isChat || isSubscriptionModalOpen || fullscreenStore.hideNav;
  console.log("hideNavigation", hideNavigation, isSubscriptionModalOpen, fullscreenStore.hideNav);
  if (user && user.displayName === DEFAULT_USER_NAME)
    return <Navigate to="/auth/post-register" />;

  return (
    <>
      <Flex position="relative" bg="primary.100" minH={maxH}>
        <IncomingMessage />
        <RequestNotificationPermission />
        <DailyReward />
        <Sidebar />
        <InstallAppDrawer />
        <Box
          width={{ base: "100%", md: 640 }}
          mx="auto"
          px={0}
          pb={hideNavigation ? 0 : `${MobileNavigation.HEIGHT}px`}
        >
          <Outlet />
        </Box>
      </Flex>
      {!hideNavigation && <MobileNavigation />}
    </>
  );
});
export default withAuthGuard(withPullToRefresh(ProtectedLayout));
